"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BootScene = void 0;
/**
 * Responsible for loading any assets that are required in the `PreloadScene`
 * state of our game.
 */

class BootScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'BootScene'
    });
  }

  /**
   * @returns {void}
   */
  preload() {
    this.load.json('animations_json', '/space-shooter-assets/data/animations.json');
  }

  /**
   * @returns {void}
   */
  create() {
    this.scene.start('PreloadScene');
  }
}
exports.BootScene = BootScene;